import React, { useEffect } from "react";
import FileTransferStatsViewTable from "./fileTransferStatsView";
import "../../util/tables.css";
import { useDataView } from "../../../contexts/data.view.context";

const columns = [
  {
    id: "transfer_id",
    accessorKey: "transfer_id",
    header: "Transfer ID",
    size: 150,
  },
  {
    id: "transferSeq",
    accessorKey: "transferSeq",
    header: "Seq",
    enableGrouping: false,
    size: 150,
  },
  {
    id: "status",
    accessorKey: "status",
    header: "Status",
    enableGrouping: false,
    size: 200,

    Cell: ({ row }) => {
      let value = row.original.status;
      value = "" + value;

      if (value === "200") {
        return <p style={{ color: "green" }}>{value}</p>;
      }

      return <p style={{ color: "red" }}>{value}</p>;
    },
  },
  {
    id: "average_30_day",
    accessorKey: "average_30_day",
    header: "30 Day Average",
    enableGrouping: false,
    size: 200,
  },
  {
    id: "average_7_day",
    accessorKey: "average_7_day",
    header: "7 Day Average",
    enableGrouping: false,
    Cell: ({ row }) => {
      let value = row.original.average_7_day;
      value = "" + value;

      if (value.includes(">")) {
        value = value.replace(/>/g, "");
        value = value.replace(/</g, "");
      }

      return <span>{value}</span>;
    },
    size: 200,
  },
  {
    id: "yesterday",
    accessorKey: "yesterday",
    header: "Yesterday",
    enableGrouping: false,
    size: 200,
    Cell: ({ row }) => {
      let value = row.original.yesterday;
      value = "" + value;

      if (value.includes(">")) {
        value = value.replace(/>/g, "");
        value = value.replace(/</g, "");
      }

      return <span>{value}</span>;
    },
  },
];

const FileTrnsStatsViewByTrnsID = () => {
  const { fetchFileTransferStatsByTransID, fileTransferStatsByTransID } =
    useDataView();
  useEffect(() => {
    (async () => {
      if (fileTransferStatsByTransID.length === 0)
        await fetchFileTransferStatsByTransID();
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="relative">

        {fileTransferStatsByTransID.length > 0 && (
          <FileTransferStatsViewTable
            columns={columns}
            data={fileTransferStatsByTransID.map((fileStats) => ({
              transfer_id: fileStats.transferId,
              transferSeq: fileStats.transferSeq,
              status: fileStats.status,
              average_30_day: fileStats.TransferCount30DayAverage,
              average_7_day: fileStats.TransferCount7DayAverage,
              yesterday: fileStats.TransferCountYesterday,
            }))}
          />
        )}
      </div>
    </>
  );
};

export default FileTrnsStatsViewByTrnsID;
